import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { BarChart3Icon, TrendingUpIcon, Users2Icon, TargetIcon, ActivityIcon, MessageSquareIcon } from 'lucide-react';
export function Reporting() {
  return <Section id="reports" className="bg-slate-50 overflow-hidden" data-id="element-7162">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-7163">
        {/* Left: Copy */}
        <div data-id="element-7164">
          <FadeIn data-id="element-7165">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-7166">
              Show the client what actually happened.
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-7167">
              Offsite+ turns event activity into a clean post-event report with
              engagement, preferences, feedback, themes, and commitments.
            </p>
            <Button variant="primary" size="lg" href="/report" data-id="element-7168">
              See Sample Report
            </Button>
          </FadeIn>
        </div>

        {/* Right: Mock Report Dashboard */}
        <FadeIn delay={0.2} className="relative" data-id="element-7169">
          <div className="absolute inset-0 bg-brand-navy/5 rounded-full blur-3xl" data-id="element-7170" />

          <div className="relative bg-white rounded-2xl shadow-soft border border-slate-100 p-6 md:p-8" data-id="element-7171">
            <div className="flex items-center justify-between mb-8" data-id="element-7172">
              <h3 className="font-bold text-xl text-brand-navy" data-id="element-7173">
                Post-Event Report
              </h3>
              <span className="bg-brand-teal/10 text-brand-teal text-xs font-bold px-3 py-1 rounded-full" data-id="element-7174">
                Final
              </span>
            </div>

            {/* Top Stats */}
            <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-7175">
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-7176">
                <div className="text-2xl font-black text-brand-navy mb-1" data-id="element-7177">
                  92%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-7178">
                  Intake
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-7179">
                <div className="text-2xl font-black text-brand-teal mb-1" data-id="element-7180">
                  78%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-7181">
                  Intros
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-7182">
                <div className="text-2xl font-black text-brand-coral mb-1" data-id="element-7183">
                  64%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-7184">
                  Wellness
                </div>
              </div>
            </div>

            {/* Connection Score */}
            <div className="bg-brand-navy text-white p-5 rounded-xl mb-6 flex items-center justify-between" data-id="element-7185">
              <div className="flex items-center gap-3" data-id="element-7186">
                <TrendingUpIcon className="w-8 h-8 text-brand-teal" data-id="element-7187" />
                <div data-id="element-7188">
                  <div className="text-sm text-slate-300" data-id="element-7189">Connection Score</div>
                  <div className="font-bold" data-id="element-7190">Improved +1.7</div>
                </div>
              </div>
              <div className="flex items-center gap-2 font-mono text-xl" data-id="element-7191">
                <span className="text-slate-400" data-id="element-7192">6.4</span>
                <span className="text-brand-teal" data-id="element-7193">→</span>
                <span className="font-bold" data-id="element-7194">8.1</span>
              </div>
            </div>

            {/* Bottom Grid */}
            <div className="grid grid-cols-2 gap-4" data-id="element-7195">
              <div className="border border-slate-100 rounded-xl p-4" data-id="element-7196">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-3" data-id="element-7197">
                  <TargetIcon className="w-4 h-4 text-brand-coral" data-id="element-7198" /> Top Goals
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-7199">
                  {['Alignment', 'Communication', 'Energy', 'Trust'].map(g => <span key={g} className="bg-slate-100 text-[10px] font-bold text-slate-600 px-2 py-1 rounded" data-id="element-7200">
                        {g}
                      </span>)}
                </div>
              </div>

              <div className="border border-slate-100 rounded-xl p-4 flex flex-col justify-center items-center text-center" data-id="element-7201">
                <MessageSquareIcon className="w-6 h-6 text-brand-teal mb-2" data-id="element-7202" />
                <div className="text-2xl font-black text-brand-navy" data-id="element-7203">43</div>
                <div className="text-xs text-slate-500 font-medium" data-id="element-7204">
                  Commitments Captured
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}